import { render } from "./InsuranceView.vue?vue&type=template&id=5c617c4e&scoped=true"
import script from "./InsuranceView.vue?vue&type=script&lang=js"
export * from "./InsuranceView.vue?vue&type=script&lang=js"

import "./InsuranceView.vue?vue&type=style&index=0&id=5c617c4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c617c4e"]])

export default __exports__